$(function() {
   setTimeout(() => {
    var swiper4 = new Swiper(".cryoBlog", {
      slidesPerView: 3,
      spaceBetween: 0,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        280: {
          slidesPerView: 2,

        },
        720: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 3,
        },
      },
    });
  }, 150);
  
});

$(function() {
  const swiper9 = new Swiper(".cryoTestimonials", {
    effect: "creative",
    slidesPerView: 1,
    allowTouchMove: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + "</span>";
      },
    },
    creativeEffect: {
      prev: {
        translate: [0, "2%", 0],
        scale: 1.05,
        opacity: 0,
      },
      next: {
        translate: [0, "-1%", 0],
        scale: 0.95,
        opacity: 1,
      },
      progressMultiplier: 1,
      limitProgress: 2,
      perspective: true,
    },
    breakpoints: {
      // Mobile
      0: {
        creativeEffect: {
          prev: {
            translate: [0, "5%", 0],
            scale: 1.02,
            opacity: 0,
          },
          next: {
            translate: [0, "6.5%", 0],
            scale: 0.925,
            opacity: 1,
          },
        },
      },
      // Tablet
      720: {
        creativeEffect: {
          prev: {
            translate: [0, "1%", 0],
            scale: 1.04,
            opacity: 0,
          },
          next: {
            translate: [0, "5.4%", 0],
            scale: 0.94,
            opacity: 1,
          },
        },
      },
      // Desktop
      1024: {
        creativeEffect: {
          prev: {
            translate: [0, "1%", 0],
            scale: 1.05,
            opacity: 0,
          },
          next: {
            translate: [0, "5.2%", 0],
            scale: 0.95,
            opacity: 1,
          },
        },
      }
    }
  });
});
